<template>
  <v-app :dark="isDark">
    <div id="app" :class="{ 'dark-mode': isDark }">
      <div class="bridge-unavailable" v-if="loading">
        Loading ⌛️
      </div>
      <div class="bridge-unavailable" v-else-if="!ok">
        Your browser not supported!
      </div>
      <v-container v-else>
        <v-list :dark="isDark">
          <v-list-item v-for="(item, i) in items" :key="i" @click="navigate(i)">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
              <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
            </v-list-item-content>
              <v-list-item-action>
                <v-btn icon small @click="navigate(i)" class="calendar-toggle-btn" color="accent">
                  <v-icon>{{ 'mdi-chevron-right' }}</v-icon>
                </v-btn>
              </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <h1>Clear dummy data?</h1>
      <v-btn color="red" @click="clearData">Yes</v-btn>
      <v-btn color="accent" @click="overlay = false" class="ml-2">NO</v-btn>
    </v-overlay>
  </v-app>
</template>

<script>
import {
  isWebViewBridgeAvailable,
  setTabActiveHandler,
  setTitle,
  backArrow,
  storage,
  headerMenuItems,
  onReady
} from '@orta/bridge';

export default {

  data() {
    return {
      loading: true,
      ok: false,
      overlay: false,
      items: [
        { text: 'Аванс', icon: 'mdi-credit-card-plus', subtitle: 'Сколько можете получить' },
        { text: 'Отпуск', icon: 'mdi-flag', subtitle: 'Запросите или посмотрите' },
        { text: 'Табель рабочего времени', icon: 'mdi-calendar-text', subtitle: 'Запросите или посмотрите' },
        { text: 'АХО', icon: 'mdi-folder-cog', subtitle: 'Материалы для работы' },
      ],
      theme: "light",
    };
  },
  beforeDestroy() {
    headerMenuItems.setItems([])
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    },
  },
  methods: {
    navigate(i) {
      switch (i) {
        case 0:
          console.log('push to advance page');
          this.$router.push({ name: "AdvanceScreen", replace: true });
          break;
        case 1:
          this.$router.push({ name: "VacationView", replace: true });
          break;
        default:
          console.log('Unhandled navigate event');
      }
    },
    tabActiveHandler() {
      this.$router.replace({
        name: 'HomeView'
      });
    },
    async clearData() {
      try {
        await storage.clear();
        localStorage.clear();
        window.location.reload();
      } catch (error) {
        alert('Error while clearing data: ' + error);
      }
    },
    async headerMenuItemClickHandler(id) {
      if (id === 'reload') {
        this.overlay = true
      }
    }
  },
  mounted() {
    onReady(async() => {
      this.ok = isWebViewBridgeAvailable()
      this.loading = false

      await setTitle('Запросы');
      await backArrow.setMode(true);
      await backArrow.setVisible(false);
      await setTabActiveHandler(this.tabActiveHandler.bind(this));

      headerMenuItems.setItems([
        {
          id: 'reload',
          icon: 'Reload',
        }
      ])
      headerMenuItems.setClickHandler(this.headerMenuItemClickHandler.bind(this))
    })
  },
  created() {
    // Get theme from route query or fallback to localStorage, with final fallback to light theme
    const themeFromQuery = this.$route.query.theme;
    const storedTheme = localStorage.getItem('theme');

    // Determine theme with priority: query param > localStorage > default
    this.theme = themeFromQuery || storedTheme || "light";

    // Store the theme in localStorage for persistence across components and navigation
    localStorage.setItem('theme', this.theme);

    console.log('HomeView created with theme:', this.theme);

    document.documentElement.classList.toggle('dark-mode', this.isDark);
  }
};
</script>


<style>
:root {
  --bg-color: #ffffff;
  --bg-color-secondary: #F0F3F6;
  --text-color: #000000;
}

.dark-mode {
  --bg-color: #121212;
  --bg-color-secondary: #1B1B1B;
  --text-color: #ffffff;
}

html.dark-mode {
  --bg-color: #121212;
  --bg-color-secondary: #1B1B1B;
  --text-color: #ffffff;
}

html, body {
  background-color: var(--bg-color) !important;
  color: var(--text-color) !important;
}

.calendar-toggle-btn {
  background-color: var(--bg-color-secondary);
}

#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: var(--bg-color);
}

.bridge-unavailable {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

</style>
